<template>
  <div>
    <b-modal  size="lg"  id="modal-customer" hide-header hide-footer>
      <customer  :in_modal="true" @fetch-options="fetchOptions" @update-customer-id="updateCustomerId"></customer>
    </b-modal>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1"
          >{{
            $router.currentRoute.name == "quotation-copy" ? "複製" : ""
          }}報價單資料</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Quotation number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="報價單編號"
                  rules="required"
                  vid="v_quotation_number"
                >
                  <b-form-group
                    label="報價單編號："
                    label-for="quotation_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-input-group>
                      <b-form-input
                        id="quotation_number"
                        v-model="newQuotationData.quotation_number"
                        placeholder="輸入報價單編號"
                        :state="getValidationState(validationContext)"
                        @blur="validateQuotationNumber"
                        :disabled="loadingQuotationNumber || !ability.can('edit_number', 'quotation_form')"
                        :readonly="!ability.can('edit_number', 'quotation_form')"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="outline-secondary"
                          @click="getNextQuotationNumber"
                          :disabled="loadingQuotationNumber || !ability.can('edit_number', 'quotation_form')"
                          size="sm"
                        >
                          <b-spinner small v-if="loadingQuotationNumber" />
                          <span v-else>自動</span>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <small v-if="quotationNumberValidation.message"
                           :class="quotationNumberValidation.isValid ? 'text-success' : 'text-danger'">
                      {{ quotationNumberValidation.message }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- quotation_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_quotation_date"
                >
                  <b-form-group
                    label="發單日期："
                    label-for="quotation_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newQuotationData.quotation_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- quotation_type -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_quotation_type_id"
                >
                  <b-form-group
                    label="類別："
                    label-for="quotation_type"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="quotation_type"
                      v-model="newQuotationData.quotation_type_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="quotationTypeOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇類別"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="customer_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newQuotationData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      @input="updateCustomer"
                      :disabled="newQuotationData.id > 0"
                      :filter="customerSearch"
                    > 
                    <template #list-header>
                        <li
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          @click="handleNewCustomer"
                          class="add-new-client-header px-2 d-flex align-items-center my-50 cursor-pointer"
                        >
                          <feather-icon icon="PlusIcon" size="16" />
                          <span
                            class="align-middle ml-25 cursor-pointer"
                            >新增客戶</span>
                        </li>
                      </template>
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- project_name -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_name"
                >
                  <b-form-group
                    label="項目名稱："
                    label-for="project_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="project_name"
                      v-model="newQuotationData.project_name"
                      placeholder="輸入項目名稱"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- address -->
              <b-col cols="12" md="6" :key="`address_${trigger}`">
                  <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_address"
                >
                  <b-form-group
                    label="施工地址："
                    label-for="address"
                    label-cols-md="3"
                  >
                     <v-select
                      id="address"
                      v-model="newQuotationData.address"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerAddresses"
                      :clearable="false"
                      :reduce="(option) => option"
                      placeholder="選擇施工地址"
                      :disabled="newQuotationData.id > 0 || !newQuotationData.customer_id"
                      :filter="customerAddressSearch"
                    > </v-select>
                      <!-- <el-autocomplete
                        class="inline-input w-100"
                        v-model="newQuotationData.address"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入内容"
                        @select="handleSelect"
                      ></el-autocomplete> -->
                  </b-form-group>
                  <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>


              <!-- customer name_cn-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="單據抬頭："
                    label-for="c_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newQuotationData.name_cn"
                      placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name_en-->
              <b-col cols="12" md="6">
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="c_name_en"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="c_name_en"
                      v-model="newQuotationData.name_en"
                      placeholder="輸入系統帳號名稱"
                    />
                
                  </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer mobile-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_mobile"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="customer_mobile"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="customer_mobile"
                      v-model="newQuotationData.mobile"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer email-->
              <b-col cols="12" md="6">
                
                  <b-form-group
                    label="電郵地址："
                    label-for="email"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="customer_email"
                      v-model="newQuotationData.email"
                      placeholder="輸入電郵地址"
                    />
                  </b-form-group>
              </b-col>

            </b-row>
            <hr />
            <!-- 工資 -->
            <h5 class="mb-3">項目摘要</h5>

            <!-- 其他成本 -->
            <b-row
              v-for="(cost, index) in newQuotationData.cost_items"
              :key="`cost_${index}`"
              class="px-1"
            >
              <b-col
                cols="12"
                class="d-flex backgroundColor3 mb-1 radius-round border-1"
              >
                <b-row class="flex-grow-1 p-2">
                  <!-- product id -->

                  <b-col cols="12" md="6">
                    <b-row>   
                      <b-col cols="12">
                          <b-form-group
                            :label="`商品分類：`"
                            :label-for="`product_category_id${index}`"
                            label-cols-md="2"
                          >
                            <v-select
                              v-model="cost.product_category_id"
                              :dir="
                                $store.state.appConfig.isRTL
                                  ? 'rtl'
                                  : 'ltr'
                              "
                              :options="productCategoriesOptions"
                              :clearable="false"
                              label="name"
                              :reduce="(option) => option.id"
                              placeholder="選擇商品分類"
                              @input="(val) => filterProductByCategory(cost)"
                              :filter="productCategorySearch"
                            >
                            </v-select>
                          </b-form-group>
                      </b-col>
                      <b-col cols="12">
                          <b-form-group
                            :label="`商品(${index + 1})：`"
                            :label-for="`product_id${index}`"
                            label-cols-md="2"
                          >
                            <v-select 
                              v-model="cost.product_id"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="cost.productOptions"
                              :clearable="false"
                              label="product_name"
                              :reduce="(option) => option.id"
                              :placeholder="cost.product_category_id == 13 ? '請在備註填寫' : '選擇商品分類內的項目'"
                              :disabled="cost.product_category_id == 13"
                              @input="(val) => updateSelectedProduct(cost, val)"
                              :filter="productSearch"
                            >
                            </v-select>
                          </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-row class="mb-1 cal-input-group">
                          <!--  -->
                          <b-col md="2" class="label">
                            金額:
                            <!-- <span class="colorRed">*</span> -->
                          </b-col>
                          <b-col md="10" class="c_content">
                            <div
                              class="content-wrapper d-flex align-items-center"
                            >
                              <b-input-group
                                class="group1"
                                size="md"
                                :append="getProduct(cost.product_id).unit"
                              >
                                <b-form-input
                                  id="cost-quantity"
                                  type="number"
                                  step="any"
                                  v-model="cost.quantity"
                                  placeholder="輸入數量"
                                  @input="calTotalCost(cost)"
                                />
                              </b-input-group>

                              <div class="operator">*</div>

                              <b-input-group
                                class="group2"
                                size="md"
                                prepend="$"
                                :append="`每${
                                  getProduct(cost.product_id).unit
                                }`"
                              >
                                <b-form-input
                                  :id="`cost_unit_price${index}`"
                                  v-model="cost.unit_price"
                                  placeholder="輸入單價"
                                  @input="calTotalCost(cost)"
                                />
                              </b-input-group>

                              <div class="operator">=</div>

                              <b-input-group
                                class="group3"
                                size="md"
                                prepend="$"
                                :key="`amount_${index}_${trigger}`"
                              >
                                <b-form-input
                                  id=""
                                  class="cost_amount"
                                  disabled
                                  type="number"
                                  :value="Number(cost.amount)"
                                  placeholder="輸入總金額"
                                />
                              </b-input-group>
                            </div>
                          </b-col>
                        </b-row>
                        <!-- <div
                          class="colorRed mt-1"
                          v-if="
                            !cost.quantity || !cost.unit_price || !cost.amount
                          "
                        >
                          <div class="mr-50" v-if="!cost.quantity">
                            請輸入數量
                          </div>
                          <div class="mr-50" v-if="!cost.unit_price">
                            請輸入單價
                          </div>
                        </div> -->
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-row> 
                      <b-col cols="12">
                          <b-form-group
                            label="增加空行數量"
                            label-for="empty_rows"
                            label-cols-md="2"
                          >
                            <b-form-input
                              type="number"
                              v-model="cost.empty_rows"
                              placeholder="輸入增加空行數量"
                            />
                          </b-form-group>
                        </b-col>
                      <!-- <b-col cols="12">
                        <b-form-group
                        label="尺寸："
                        label-for="size"
                        label-cols-md="2"
                      >
                        <b-form-input
                          id="size"
                          v-model="cost.size"
                          placeholder="輸入尺寸"
                        />
                      </b-form-group>
                      </b-col> -->
                      <!-- item_description -->
                      <b-col cols="12">
                       
                        <b-form-group
                          label="備註/尺寸："
                          :label-for="`cost-item_description${index}`"
                          label-cols-md="2"
                        >
                          <b-form-textarea
                            :id="`cost-item_description${index}`"
                            v-model="cost.item_description"
                            rows="4"
                            placeholder="輸入備註/尺寸"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <div
                  class="d-flex flex-column justify-content-between py-50 px-25"
                >
                  <feather-icon
                    size="16"
                    icon="PlusIcon"
                    class="cursor-pointer text-success"
                    @click="addItem('cost_items', index)"
                  />
                  <feather-icon
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer text-danger"
                    @click="removeItem('cost_items', index, cost.id)"
                  />
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6" v-if="$route.name != 'quotation-edit'">
                <div class="d-flex align-items-center">
                  <div class="label-title">
                    <span>優惠卷：</span>
                  </div>
                    <v-select
                      id="coupon_id"
                      class="flex-1"
                      v-model="newQuotationData.coupon_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="couponOptions"
                      :clearable="true"
                      label="name"
                      :reduce="(option) => option.id"
                      :placeholder="newQuotationData.customer_id ? '選擇優惠卷' : '請先選擇客戶'"
                      :disabled="!newQuotationData.customer_id"
                      :filter="couponSearch"
                    >
                      <template
                        #option="{ code, amount, percentage, total_amount }"
                      >
                        [{{ code }}]
                        {{ amount ? "$" + amount : percentage + "%" }}折扣{{
                          Number(total_amount)
                            ? ` (優惠券生效前必須達到${total_amount})`
                            : ""
                        }}
                      </template>
                      <template
                        #selected-option="{
                          code,
                          amount,
                          percentage,
                          total_amount,
                        }"
                      >
                        [{{ code }}]
                        {{ amount ? "$" + amount : percentage + "%" }}折扣{{
                          Number(total_amount)
                            ? ` (優惠券生效前必須達到${total_amount})`
                            : ""
                        }}
                      </template>
                    </v-select>
                </div>
                <span
                  class="colorRed"
                  v-if="
                    getCoupon(newQuotationData.coupon_id) &&
                    getCoupon(newQuotationData.coupon_id).total_amount &&
                    getCoupon(newQuotationData.coupon_id).total_amount >
                      newQuotationData.amount
                  "
                >
                  你的金額未達到要求
                </span>
              </b-col>

              <b-col cols="12" md="6" v-if="$route.name != 'quotation-edit'">
                <div class="d-flex align-items-center">
                  <div class="label-title">
                    <span>購物禮卷：</span>
                  </div>
                    <v-select
                      id="gift_voucher_id"
                      class="flex-1"
                      v-model="newQuotationData.gift_voucher_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="giftOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      :placeholder="newQuotationData.customer_id ? '選擇購物禮卷' : '請先選擇客戶'"
                      :disabled="!newQuotationData.customer_id"
                      :filter="giftSearch"
                    >
                      <template #option="{ code, amount }">
                        [{{ code }}] {{ amount }}
                      </template>
                      <template #selected-option="{ code, amount }">
                        [{{ code }}] {{ amount }}
                      </template>
                    </v-select>
                </div>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- remark -->
              <b-col cols="12" md="12">
                <div>單據備註：</div>
                <b-form-group label="" label-for="remark_id">
                  <v-select
                    id="remark_id"
                    v-model="newQuotationData.quotation_description_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="quotationDescriptionOptions"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇單據備註"
                    :filter="quotationDescriptionSearch"
                    :disabled="
                      !ability.can('quotoation_remark', 'quotation_form')
                    "
                    :readonly="
                      !ability.can('quotoation_remark', 'quotation_form')
                    "
                  >
                  </v-select>
                </b-form-group>
                <b-form-group label="" label-for="remark">
                  <b-form-textarea
                    id="remark"
                    v-model="newQuotationData.remark"
                    placeholder="輸入單據備註"
                    autofocus
                    trim
                    class="textarea"
                    :key="`remark${trigger}`"
                    :disabled="
                      !ability.can('quotoation_remark', 'quotation_form')
                    "
                    :readonly="
                      !ability.can('quotoation_remark', 'quotation_form')
                    "
                  />
                </b-form-group>
                <!-- <div
                  class="d-flex flex-wrap flex-md-nowrap full_input"
                >
                  <label>單據備註：</label>
                  <div class="input_wrap">

                    <b-form-textarea
                      id="remark"
                      v-model="newQuotationData.remark"
                      rows="4"
                      placeholder="輸入單據備註"
                    />
                  </div>
                </div> -->
              </b-col>
              <b-col cols="8"></b-col>
              <b-col cols="4" class="amount-block">
                <b-row class="">
                  <!-- amount -->
                  <b-col cols="12">
                    <validation-provider
                      #default="validationContext"
                      name="此欄"
                      rules="required"
                      vid="v_amount"
                    >
                      <b-form-group
                        label="總額："
                        label-for="amount"
                        label-cols-md="4"
                      >
                        <b-form-input
                          id="quotation_amount"
                          v-model="newQuotationData.amount"
                          placeholder="輸入總額"
                          :disabled="true"
                          :state="getValidationState(validationContext)"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <!-- coupon_info -->
                  <b-col cols="12">
                    <b-form-group
                      :label="`優惠卷${
                        coupon_info.title ? '(' + coupon_info.title + ')' : ''
                      }折扣：`"
                      label-for="coupon_info"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="coupon_info"
                        v-model="coupon_info.amount"
                        placeholder="輸入優惠卷折扣"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- gift_info -->
                  <b-col cols="12">
                    <b-form-group
                      :label="`購物禮卷${
                        gift_info.code ? '(' + gift_info.code + ')' : ''
                      }折扣：`"
                      label-for="gift_info"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="gift_info"
                        v-model="gift_info.amount"
                        placeholder="輸入購物禮卷折扣"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- total_amount -->
                  <b-col cols="12">
                    <b-form-group
                      label="報價單總額："
                      label-for="total_amount"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="total_amount"
                        v-model="total_amount"
                        placeholder="輸入報價單總額"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <!-- company stamp -->
              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="公司印章："
                  label-for="stamp_id"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    name="stamp"
                    switch
                    inline
                    v-model="newQuotationData.stamp"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{ newQuotationData.stamp ? "有" : "無" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->
              <!-- template id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_template_id"
                >
                  <b-form-group
                    label="選擇模版："
                    label-for="stamp"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="stamp"
                      v-model="newQuotationData.template_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="templateOptions"
                      :clearable="false"
                      label="template_name"
                      :reduce="(option) => option.id"
                      placeholder="選擇模版"
                      @input="changeTemplate"
                      :filter="templateSearch"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- stamp_id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="選擇印章："
                  label-for="stamp"
                  label-cols-md="3"
                >
                  <v-select
                    id="stamp"
                    v-model="newQuotationData.stamp_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="stampOptions"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇印章"
                    :filter="stampSearch"
                  >
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>

            <div>
              <b-row
                class="d-flex mb-1 justify-content-between align-items-center"
              >
                <b-col class="mb-1 mb-sm-0" cols="12" md="6">
                  <div class="mb-5">客戶蓋章或簽署：</div>
                  <br />
                  <div class="d-flex align-items-center">
                    <span class="text-nowrap">日期：</span
                    ><flat-pickr
                      v-model="newQuotationData.date1"
                      class="form-control just-line"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                    />
                  </div>
                </b-col>
                <b-col class="mb-1 mb-sm-0" cols="12" md="6">
                  <div class="">永發設計工程有限公司</div>
                  <div class="mb-5">公司蓋章或簽署：</div>
                  <div class="d-flex align-items-center">
                    <span class="text-nowrap">日期：</span>
                    <flat-pickr
                      v-model="newQuotationData.date2"
                      class="form-control just-line"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                    />
                  </div>
                </b-col>
              </b-row>

              <div class="mt-3">
                <div>備註：</div>
                <b-form-group label="" label-for="remark_id">
                  <v-select
                    id="remark_id"
                    v-model="newQuotationData.remark_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pdfRemarkOptions"
                    :clearable="true"
                    label="title"
                    :reduce="(option) => option.id"
                    placeholder="選擇備註"
                    :filter="pdfRemarkSearch"
                    :disabled="
                      !ability.can('pdf_remark', 'quotation_form')
                    "
                    :readonly="
                      !ability.can('pdf_remark', 'quotation_form')
                    "
                  >
                  </v-select>
                </b-form-group>
                <b-form-group label="" label-for="quotation_remark">
                  <b-form-textarea
                    id="quotation_remark"
                    v-model="newQuotationData.quotation_remark"
                    placeholder="備註"
                    autofocus
                    trim
                    class="textarea"
                    :key="`quotation_remark_${trigger}`"
                    :disabled="
                      !ability.can('pdf_remark', 'quotation_form')
                    "
                    :readonly="
                      !ability.can('pdf_remark', 'quotation_form')
                    "
                  />
                </b-form-group>
                <hr />
                <b-row>
                  <b-col cols="12">
                    地址: {{info.address}}
                  </b-col>
                  <b-col cols="12" md="6"> 網址: {{info.website}} </b-col>
                  <b-col cols="12" md="6"> 電話: {{info.phone}} </b-col>
                  <b-col cols="12" md="6">
                    電郵: {{info.email}}
                  </b-col>
                  <b-col cols="12" md="6"> 傳真:{{info.fax}} </b-col>
                </b-row>
              </div>
            </div>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BOverlay,
  BSpinner,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, onMounted, nextTick } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { getDateTime } from "@/libs/helper";
import Customer from "@/views/user/customer/customer-edit/customerEdit.vue";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      required,
      email,
      ability,
      initial:true
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BSpinner,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Customer
  },
  methods: {
    hide() {
      this.$router.replace("/quotations/list");
    },
    filterProductByCategory(cost) {
      cost.product_id = null;
      cost.productOptions = this.productOptions.filter(product => product.product_category_id == cost.product_category_id)
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === 'string') {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === 'object' && str.content) {
        return typeof str.content === 'string' ? str.content.replace(/\n/g, "<br>") : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === 'object' && str.title) {
        return typeof str.title === 'string' ? str.title.replace(/\n/g, "<br>") : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === 'number' || typeof str === 'boolean') {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str.map(item =>
          typeof item === 'string' ? item :
          (typeof item === 'object' && item.content) ? item.content :
          String(item)
        ).join('<br>');
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== '[object Object]' ? stringValue : "";
      } catch (error) {
        console.warn('changeNextLine: 無法處理的資料類型', str);
        return "";
      }
    },
    handleNewCustomer(){
      this.$bvModal.show('modal-customer')
    },
    fetchOptions() {
      this.$emit('fetch-options');
    },  
    updateCustomerId(id) {
        this.newQuotationData.customer_id = id
        // 標記待處理的新客戶，待 customerOptions 重新載入後自動帶入第一個地址
        this.pendingNewCustomerId = id
    },
    // checkVaild() {
    //   let isVaild = true;

    //   this.newQuotationData.cost_items &&
    //     this.newQuotationData.cost_items.length > 0 &&
    //     this.newQuotationData.cost_items.forEach((ele) => {
    //       if (ele.quantity === null || ele.quantity === undefined || ele.quantity === '' ||
    //           ele.unit_price === null || ele.unit_price === undefined || ele.unit_price === '' ||
    //           ele.amount === null || ele.amount === undefined || ele.amount === '') {
    //         isVaild = false;
    //       }
    //     });
    //   return isVaild;
    // },
    onSubmit() {
      // if (!this.checkVaild()) {
      //   return;
      // }
     if (this.newQuotationData.cost_items && this.newQuotationData.cost_items.length > 0) {
      this.newQuotationData.cost_items.forEach((item, index) => {
        item.item_description = this.changeNextLine(item.item_description);
        item.sort_order = index + 1;
        item.empty_rows = item.empty_rows || 0;
      });
     }

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("quotation/editQuotation", this.newQuotationData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              // this.$emit("refetch-data");
              // if (this.newQuotationData.id == 0) {
              //   this.newQuotationData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },

    addItem(key, index) {
      const newItem = JSON.parse(
        JSON.stringify({
          id: 0,
          empty_rows: 0,
        })
      );
      
      if (index !== undefined) {
        this.newQuotationData[key].splice(index + 1, 0, newItem);
      } else {
        this.newQuotationData[key].push(newItem);
      }
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newQuotationData &&
        this.newQuotationData[key] &&
        this.newQuotationData[key].length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
          this.newQuotationData[key].splice(index, 1);
      }
      this.calTotalAmount()
    },
    querySearch(queryString, cb) {
      var customerAddresses = this.customerAddresses;
      var results = queryString ? customerAddresses.filter(this.createFilter(queryString)) : customerAddresses;
      // 調用 callback 返回建議列表的數據
      cb(results);
    },
    customerSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase()) || item.user_number.toLowerCase().includes(search.toLowerCase());
      });
    },
    customerAddressSearch(options, search) {
      return options.filter((item) => {
        return item.toLowerCase().includes(search.toLowerCase());
      });
    },
    productCategorySearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    productSearch(options, search) {
      return options.filter((item) => {
        return item.product_name.toLowerCase().includes(search.toLowerCase());
      });
    },
    couponSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    giftSearch(options, search) {
      return options.filter((item) => {
        return item.code.toLowerCase().includes(search.toLowerCase());
      });
    },
    quotationDescriptionSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    templateSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    stampSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    pdfRemarkSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    createFilter(queryString) {
      return (customerAddress) => {
        return (customerAddress.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    }
  },
  props: {
    quotationData: {
      type: Object,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    quotationTypeOptions: {
      type: Array,
      required: true,
    },
    productUnitOptions: {
      type: Array,
      required: true,
    },
    quotationDescriptionOptions: {
      type: Array,
      required: true,
    },
    pdfRemarkOptions: {
      type: Array,
      required: true,
    },
    productCategoriesOptions: {
      type: Array,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    newQuotationData: {
      handler() {
        if (this.newQuotationData.amount) {
          if (router.currentRoute.name != "quotation-edit") {
            if (this.newQuotationData.coupon_id) {
              this.coupon_info.title = this.getCoupon(
                this.newQuotationData.coupon_id
              ).title;
              if (
                this.getCoupon(this.newQuotationData.coupon_id).total_amount
              ) {
                if (
                  this.newQuotationData.amount <
                  this.getCoupon(this.newQuotationData.coupon_id).total_amount
                ) {
                  this.coupon_info.amount = 0;
                } else {
                  if (this.getCoupon(this.newQuotationData.coupon_id).amount) {
                    this.coupon_info.amount = this.getCoupon(
                      this.newQuotationData.coupon_id
                    ).amount;
                  } else {
                    this.coupon_info.amount =
                      this.newQuotationData.amount *
                      (this.getCoupon(this.newQuotationData.coupon_id)
                        .percentage /
                        100);

                    this.coupon_info.percentage = this.getCoupon(
                      this.newQuotationData.coupon_id
                    ).percentage;
                  }
                }
              }
            } else {
              this.coupon_info.title = null;
              this.coupon_info.amount = 0;
            }

            if (this.newQuotationData.gift_voucher_id) {
              this.gift_info.code = this.getGift(
                this.newQuotationData.gift_voucher_id
              ).title;
              this.gift_info.amount = this.getGift(
                this.newQuotationData.gift_voucher_id
              ).amount;
            } else {
              this.gift_info.code = null;
              this.gift_info.amount = 0;
            }
          } else {
            if (
              this.newQuotationData.coupon_record &&
              this.newQuotationData.coupon_record.percentage
            ) {
              this.coupon_info.amount =
                (this.newQuotationData.amount *
                  this.newQuotationData.coupon_record.percentage) /
                100;
            }
          }
          if (
            this.newQuotationData.coupon_record &&
            this.newQuotationData.coupon_record.percentage
          ) {
            this.coupon_info.amount =
              (this.newQuotationData.amount *
                this.newQuotationData.coupon_record.percentage) /
              100;
          }
          this.total_amount =
            Number(this.newQuotationData.amount) -
            Number(this.coupon_info.amount) -
            Number(this.gift_info.amount);

          this.total_amount =
            this.total_amount > 0 ? Math.round(this.total_amount * 100) / 100 : 0;


            if(this.initial){
              const choosen_products = this.newQuotationData.cost_items.map(ele => ele.product_id);
              

              this.newQuotationData.cost_items.forEach(item => {
                item.productOptions = this.productOptions.filter(product => {
                  const isSameCategory = product.product_category_id === item.product_category_id;
                  const isNotChosen = !choosen_products.includes(product.id) || product.id === item.product_id;
                  return isSameCategory && isNotChosen;
                });
                if(item.product_id && !item.size){
                  item.size = this.getProduct(item.product_id).size;
                }
              });
              this.initial = false
            }
        }
      },
      deep: true,
    },
    
  },
  setup(props, { emit }) {
    const newQuotationData = ref({
      id: 0,
      stamp: 1,
      quotation_number: null,
      cost_items: [{ id: 0, productOptions: [] }],
      address: "",
      amount: 0,
      coupon_id: null,
      gift_voucher_id: null,
      quotation_description_id: null,
      remark: "",
      remark_id: null,
      quotation_remark: "",
    });

    const customer = ref({
      name: "",
      name_en: "",
      mobile: "",
      email: "",
    });

    const trigger = ref(false);
    const loadingQuotationNumber = ref(false);
    const quotationNumberValidation = ref({
      message: '',
      isValid: true
    });

    const coupon_info = ref({
      title: null,
      amount: 0,
      percentage: 0,
    });
    const gift_info = ref({
      code: null,
      amount: 0,
    });
    const total_amount = ref(0);

    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
    });

    const changeTemplate = (id) => {
      let template =  props.templateOptions && props.templateOptions.length > 0 && props.templateOptions.find(ele => ele.id == id);
      info.value.website = template.website;
      info.value.address = template.address;
      info.value.phone = template.phone;
      info.value.fax = template.fax;
      info.value.email = template.email;
    }


    const customerAddresses = ref([])
    const getCustomerAddresses = (id) => {
        const target = props.customerOptions.find(customer => {
          return customer.id === id;
        })
        if(target && target.customer_addresses && target.customer_addresses.length > 0){
          customerAddresses.value = target.customer_addresses.filter(ele => (ele != null)) || [];
          newQuotationData.value.address = customerAddresses.value ?  customerAddresses.value[0] : null;
        }
    }

    const updateCustomer = () => {
      var id = newQuotationData.value.customer_id
      newQuotationData.value.address = null
      getCustomerAddresses(id);
    }

    // 新增客戶後，等客戶選項重新載入完成，再自動帶入該客戶的第一個地址
    const pendingNewCustomerId = ref(null)
    watch(
      () => props.customerOptions,
      () => {
        if (!pendingNewCustomerId.value) return;
        const exists = props.customerOptions.find(
          (customer) => customer.id === pendingNewCustomerId.value
        );
        if (exists) {
          newQuotationData.value.customer_id = pendingNewCustomerId.value;
          updateCustomer();
          pendingNewCustomerId.value = null;
        }
      }
    )

    var init = true
    const isInitQuotationDescription = ref(true);
    const isInitQuotationRemark = ref(true);
    const isInitQuotationRemarkId = ref(true);
    watch(
      () => props.quotationData,
      (newVal) => {
        newQuotationData.value = { ...newVal };

        newQuotationData.value.quotation_date = newQuotationData.value
          .quotation_date
          ? newQuotationData.value.quotation_date
          : getDateTime(new Date(), 1);

        if (router.currentRoute.name == "quotation-copy") {
          newQuotationData.value.id = 0;
          newQuotationData.value.cost_items =
            newQuotationData.value.cost_items.map((item) => {
              item.id = 0;
              return item;
            });

          coupon_info.value.amount = 0;
          coupon_info.value.percentage = 0;
          coupon_info.value.title = null;
          gift_info.value.code = null;
          gift_info.value.amount = 0;
          if (newQuotationData.value.coupon_record) {
            newQuotationData.value.coupon_record = null;
          }
          if (newQuotationData.value.gift_voucher_record) {
            newQuotationData.value.gift_voucher_record = null;
          }

          newQuotationData.value.total_amount = 0;

          // 修復報價單複製時 productOptions 載入問題
          // 需要在下一個 tick 執行，確保 props.productOptions 已經可用
          nextTick(() => {
            if (props.productOptions && props.productOptions.length > 0) {
              newQuotationData.value.cost_items.forEach((item) => {
                if (item.product_category_id) {
                  // 為每個項目設定對應的 productOptions
                  item.productOptions = props.productOptions.filter(
                    (product) => product.product_category_id == item.product_category_id
                  );
                  console.log(`報價單複製：為項目 ${item.item_description} 載入了 ${item.productOptions.length} 個產品選項`);
                }
              });
            }
          });
        }

        if (newQuotationData.value.coupon_record) {
          coupon_info.value.title = newQuotationData.value.coupon_record.title;
          if (newQuotationData.value.coupon_record.percentage) {
            coupon_info.value.percentage =
              newQuotationData.value.coupon_record.percentage;
          } else {
            coupon_info.value.amount =
              newQuotationData.value.coupon_record.amount;
          }
        }
        if (newQuotationData.value.gift_voucher_record) {
          gift_info.value.code =
            newQuotationData.value.gift_voucher_record.code;
          gift_info.value.amount =
            newQuotationData.value.gift_voucher_record.amount;
        }

        changeTemplate(newQuotationData.value.template_id)
        if(init){
          updateCustomer()
          init = false
          
        }
      }
    );

    watch(
      () => newQuotationData.value.quotation_description_id,
      (newVal) => {
        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "quotation-edit" &&
          isInitQuotationDescription.value
        ) {
          console.log("報價單編輯模式初始載入，跳過單據備註自動填入");
          isInitQuotationDescription.value = false;
          return;
        }

        if (
          props.quotationDescriptionOptions &&
          props.quotationDescriptionOptions.length > 0 &&
          newVal
        ) {
          const selectedOption = props.quotationDescriptionOptions.find(
            (ele) => ele.id == newVal
          );
          if (selectedOption) {
            console.log("用戶主動選擇報價單單據備註，更新內容 - ID:", newVal, "內容:", selectedOption.description);
            newQuotationData.value.remark = selectedOption.description;
          }
        }

        // trigger.value = !trigger.value;
      }
    );

    watch(
      () => newQuotationData.value.remark_id,
      (newVal) => {
        console.log("報價單 remark_id 變更:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "quotation-edit" &&
          isInitQuotationRemarkId.value
        ) {
          console.log("報價單編輯模式初始載入，跳過備註 Remarks 自動填入（remark_id watch）");
          isInitQuotationRemarkId.value = false;
          return;
        }

        if (
          props.pdfRemarkOptions &&
          props.pdfRemarkOptions.length > 0 &&
          newVal
        ) {
          const selectedOption = props.pdfRemarkOptions.find(
            (ele) => ele.id == newVal
          );
          if (selectedOption) {
            console.log("用戶主動選擇報價單備註 Remarks，更新內容 - ID:", newVal, "內容:", selectedOption.content);
            newQuotationData.value.quotation_remark = selectedOption.content;
          }
        }

        // trigger.value = !trigger.value;
      }
    );

    // 監聽 pdfRemarkOptions 的變化，當選項加載完成時設定備註內容
    watch(
      () => props.pdfRemarkOptions,
      (newVal) => {
        console.log("報價單 pdfRemarkOptions 更新:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "quotation-edit" &&
          isInitQuotationRemark.value
        ) {
          console.log("報價單編輯模式初始載入，跳過備註 Remarks 自動填入");
          isInitQuotationRemark.value = false;
          return;
        }

        if (newVal && newVal.length > 0 && newQuotationData.value.remark_id) {
          const selectedOption = newVal.find(
            (ele) => ele.id == newQuotationData.value.remark_id
          );
          if (selectedOption && selectedOption.content) {
            console.log(
              "選項載入完成，自動填入報價單備註模板內容 - ID:",
              newQuotationData.value.remark_id,
              "內容:",
              selectedOption.content
            );
            // 只有在 quotation_remark 為空時才自動填入模板內容
            if (!newQuotationData.value.quotation_remark || newQuotationData.value.quotation_remark === '') {
              newQuotationData.value.quotation_remark = selectedOption.content;
            }
          }
        }
      },
      { immediate: true }
    );

    watch(
      () => newQuotationData.value.customer_id,
      (newVal) => {
        if (router.currentRoute.name != "quotation-edit") {
          resetCoupon();
          getUserCoupon(newQuotationData.value.customer_id);
        }

        if (router.currentRoute.name == "quotation-edit") {
          return;
        }
        if (props.customerOptions && props.customerOptions.length > 0) {
          customer.value = props.customerOptions.filter(
            (ele) => ele.id == newVal
          )[0];
          if (customer.value) {
            newQuotationData.value.name_cn = customer.value.name_cn;
            newQuotationData.value.name_en = customer.value.name;
            newQuotationData.value.mobile = customer.value.phone;
            newQuotationData.value.email = customer.value.email;
          }
        }
        
        // 當客戶ID改變時，載入客戶地址選項
        if (newVal && newVal !== null) {
          updateCustomer();
        }
      }
    );

    const couponOptions = ref([]);
    const giftOptions = ref([]);
    const getUserCoupon = (id) => {
      store
        .dispatch("app/getUserCoupon", {
          customer_id: id,
        })
        .then((response) => {
          couponOptions.value = response.data.coupons;
        });

      store
        .dispatch("app/getUserGiftVoucher", {
          customer_id: id,
        })
        .then((response) => {
          giftOptions.value = response.data.gift_vouchers;
        });
    };
    const resetCoupon = () => {
      if (router.currentRoute.name == "quotation-create") {
        coupon_info.value.amount = 0;
        gift_info.value.amount = 0;
        newQuotationData.value.coupon_id = null;
        newQuotationData.value.gift_voucher_id = null;
      }
    };

    const getProduct = (id) => {
      if (id) {
        const obj =
          props.productOptions &&
          props.productOptions.length > 0 &&
          props.productOptions.filter((ele) => ele.id == id)[0];

        if (obj) {
          let product_unit_id = obj.product_unit_id;
          if (product_unit_id) {
            let product_unit = props.productUnitOptions.filter(
              (ele) => ele.id == product_unit_id
            )[0];
            if (product_unit) {
              obj.unit = product_unit.name;
            }
          }
        }
        return { ...{ unit: "次" }, ...obj };
      } else {
        return { unit: "次" };
      }
    };

    const updateSelectedProduct = (_product, _product_id, idx) => {
      let product = getProduct(_product_id);
      console.log('_product.size', product.size)
      _product.quantity = 1;
      _product.size = product.size;
      _product.unit_price = product.unit_price;
      _product.item_description = product.product_name + (product.remark ? '\n' + product.remark : '')
      _product.amount = Number(_product.quantity) * Number(_product.unit_price);
      
      const choosen_products = newQuotationData.value.cost_items.map(ele => ele.product_id);

      newQuotationData.value.cost_items.forEach(item => {
        item.productOptions = props.productOptions.filter(product => {
          const isSameCategory = product.product_category_id === item.product_category_id;
          const isNotChosen = !choosen_products.includes(product.id) || product.id === item.product_id;
          return isSameCategory && isNotChosen;
        });
      });
   
      calTotalAmount();
    };

    const calTotalCost = (item) => {
      if (item.quantity && item.unit_price) {
        item.amount = Math.round(Number(item.quantity) * Number(item.unit_price) * 10) / 10;
        calTotalAmount();
      }
      // trigger.value = !trigger.value;
    };

    const calTotalAmount = () => {
      let total = 0;
      if (
        newQuotationData.value.cost_items &&
        newQuotationData.value.cost_items.length > 0
      ) {
        total += newQuotationData.value.cost_items.reduce(
          (a, b) =>
            a +
            (Number(b.quantity) * Number(b.unit_price)
              ? Number(b.quantity) * Number(b.unit_price)
              : 0),
          0
        );
      }
      newQuotationData.value.amount = Math.round(total * 10) / 10;
    };

    const getCoupon = (id) => {
      if (id) {
        const obj =
          couponOptions.value &&
          couponOptions.value.length > 0 &&
          couponOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return;
      }
    };
    const getGift = (id) => {
      if (id) {
        const obj =
          giftOptions.value &&
          giftOptions.value.length > 0 &&
          giftOptions.value.find((ele) => ele.id == id);

        return { ...obj };
      } else {
        return;
      }
    };

    const resetQuotationData = () => {
      newQuotationData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          stamp: 1,
          salary_items: [{ id: 0 }],
          cost_items: [{ id: 0 }],
          coupon_id: null,
          gift_voucher_id: null,
        })
      );
    };

    const loading = ref(false);

    // 獲取下一個報價單編號
    const getNextQuotationNumber = async () => {
      try {
        console.log('🔄 開始獲取報價單編號...');
        loadingQuotationNumber.value = true;
        quotationNumberValidation.value = { message: '', isValid: true };

        const response = await store.dispatch('quotation/getNextQuotationNumber');
        if (response.data && response.data.quotation_number) {
          console.log('✅ 成功獲取報價單編號:', response.data.quotation_number);
          newQuotationData.value.quotation_number = response.data.quotation_number;
          quotationNumberValidation.value = {
            message: '已自動生成編號',
            isValid: true
          };
        }
      } catch (error) {
        console.error('❌ 獲取報價單編號失敗:', error);
        quotationNumberValidation.value = {
          message: '獲取編號失敗，請手動輸入',
          isValid: false
        };
      } finally {
        loadingQuotationNumber.value = false;
      }
    };

    // 驗證報價單編號唯一性
    const validateQuotationNumber = async () => {
      if (!newQuotationData.value.quotation_number) {
        quotationNumberValidation.value = { message: '', isValid: true };
        return;
      }

      try {
        const response = await store.dispatch('quotation/validateQuotationNumber', {
          quotation_number: newQuotationData.value.quotation_number,
          exclude_id: newQuotationData.value.id > 0 ? newQuotationData.value.id : null
        });

        if (response.data) {
          quotationNumberValidation.value = {
            message: response.data.message,
            isValid: response.data.is_unique
          };
        }
      } catch (error) {
        quotationNumberValidation.value = {
          message: '驗證失敗',
          isValid: false
        };
        console.error('驗證報價單編號失敗:', error);
      }
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetQuotationData);

    // 組件掛載時自動獲取報價單編號
    onMounted(() => {
      console.log("🚀 組件已掛載，檢查報價單編號...");
      console.log("📊 當前數據:", {
        id: newQuotationData.value.id,
        quotation_number: newQuotationData.value.quotation_number
      });

      // 如果是新報價單且沒有編號，自動獲取下一個編號
      if ((!newQuotationData.value.id || newQuotationData.value.id === 0) && !newQuotationData.value.quotation_number) {
        console.log("🎯 符合條件，開始獲取編號...");
        getNextQuotationNumber();
      } else {
        console.log("⏭️ 不需要獲取編號");
      }
    });

    // 監聽 props 變化
    watch(
      () => props.quotationData,
      (newVal) => {
        console.log("📥 props.quotationData 更新:", newVal);

        // 保留已設置的 quotation_number（如果存在）
        const existingQuotationNumber = newQuotationData.value.quotation_number;
        console.log("💾 保存現有編號:", existingQuotationNumber);

        // 保留用戶可能已經修改的備註內容
        const existingRemark = newQuotationData.value.remark;
        const existingQuotationRemark = newQuotationData.value.quotation_remark;
        console.log("💾 保存現有備註:", { remark: existingRemark, quotation_remark: existingQuotationRemark });

        newQuotationData.value = { ...newVal };

        // 如果用戶已經修改了備註內容，保留用戶的修改
        if (existingRemark && existingRemark !== '' && existingRemark !== newVal.remark) {
          console.log("🔄 恢復用戶自訂的單據備註:", existingRemark);
          newQuotationData.value.remark = existingRemark;
        }
        if (existingQuotationRemark && existingQuotationRemark !== '' && existingQuotationRemark !== newVal.quotation_remark) {
          console.log("🔄 恢復用戶自訂的備註 Remarks:", existingQuotationRemark);
          newQuotationData.value.quotation_remark = existingQuotationRemark;
        }

        // 如果新數據沒有 quotation_number 但我們已經設置了，則保留它
        if (!newQuotationData.value.quotation_number && existingQuotationNumber) {
          console.log("🔄 恢復編號:", existingQuotationNumber);
          newQuotationData.value.quotation_number = existingQuotationNumber;
        }

        // 如果是新報價單且沒有編號，自動獲取下一個編號
        if ((!newQuotationData.value.id || newQuotationData.value.id === 0) && !newQuotationData.value.quotation_number) {
          console.log("🆕 新報價單需要編號，自動獲取...");
          getNextQuotationNumber();
        }
      }
    );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newQuotationData,
      getProduct,
      calTotalCost,
      calTotalAmount,
      trigger,
      updateSelectedProduct,
      couponOptions,
      giftOptions,
      getGift,
      getCoupon,
      coupon_info,
      gift_info,
      total_amount,
      resetCoupon,
      changeTemplate,
      updateCustomer,
      customerAddresses,
      pendingNewCustomerId,
      info,
      // 新增的報價單編號相關功能
      loadingQuotationNumber,
      quotationNumberValidation,
      getNextQuotationNumber,
      validateQuotationNumber,
    };

    // 監聽 props.productOptions 變化，處理報價單複製時的 productOptions 載入
    watch(
      () => props.productOptions,
      (newProductOptions) => {
        if (newProductOptions && newProductOptions.length > 0 && router.currentRoute.name == "quotation-copy") {
          console.log("props.productOptions 變化，重新載入報價單複製的 productOptions");
          nextTick(() => {
            newQuotationData.value.cost_items.forEach((item) => {
              if (item.product_category_id) {
                // 為每個項目設定對應的 productOptions
                item.productOptions = newProductOptions.filter(
                  (product) => product.product_category_id == item.product_category_id
                );
                console.log(`監聽器：為項目 ${item.item_description} 載入了 ${item.productOptions.length} 個產品選項`);
              }
            });
          });
        }
      },
      { immediate: true, deep: true }
    );

    return {
      newQuotationData,
      loading,
      onSubmit,
      hide,
      makeToast,
      addItem,
      removeItem,
      calTotalCost,
      calTotalAmount,
      filterProductByCategory,
      productCategorySearch,
      productSearch,
      customerSearch,
      projectSearch,
      trigger,
      updateSelectedProduct,
      couponOptions,
      giftOptions,
      getGift,
      getCoupon,
      coupon_info,
      gift_info,
      total_amount,
      resetCoupon,
      changeTemplate,
      updateCustomer,
      customerAddresses,
      pendingNewCustomerId,
      info,
      // 新增的報價單編號相關功能
      loadingQuotationNumber,
      quotationNumberValidation,
      getNextQuotationNumber,
      validateQuotationNumber,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
#modal-customer___BV_modal_outer_{
  .modal-dialog.modal-lg{
    width: 1200px;
    max-width: 1200px!important;
    .modal-content{
      width: 1200px;
    }
  }
}
</style>

<style lang="scss" scoped>
ol li {
  margin-bottom: 0.5rem;
}
.label-title {
  width: 9.7vw;
}
.amount-block {
}
</style>
